<div class="panel" [class.expand]="sidebarOpen">

  <aside class="sidebar" [class.closed]="!sidebarOpen">
    <app-aside></app-aside>
  </aside>

  <div class="panel-content" [class.expand]="!sidebarOpen">
    <header>
      <app-haeder [sidebarOpen]="sidebarOpen" (sidebarToggle)="toggleSidebar()"></app-haeder>
      <app-startup-profile-haeder></app-startup-profile-haeder>
    </header>

    <main class="main-panel">
      <router-outlet></router-outlet>
    </main>
  </div>


</div>

<p-toast></p-toast>
<p-toast key="pending"></p-toast>